(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/static-tabs/assets/javascripts/static-tabs.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/static-tabs/assets/javascripts/static-tabs.js');

'use strict';

const {
  useEffect,
  useMemo,
  useState
} = React;
const {
  withRouter
} = svs.app.ReactRouter;
const {
  ItemsMenu,
  LinkItem
} = svs.ui.ReactItemsMenu;
const {
  useCurrentTab
} = svs.racing_game.components.hooks;
const {
  useNavigationActions
} = svs.racing.navigation;
const logger = new svs.core.log.Logger('racing_game.components.staticTabs');
const loadModuleComponent = svs.core.module.loadModuleComponent;
const tryGetComponent = func => {
  try {
    return func();
  } catch (e) {
    return undefined;
  }
};
const StaticTabsContent = withRouter(_ref => {
  let {
    match,
    location,
    tabs
  } = _ref;
  const currentTab = useCurrentTab(match, location);
  const tabData = useMemo(() => tabs.find(element => element.param === currentTab), [currentTab, tabs]);
  const [componentToRender, setComponentToRender] = useState(undefined);
  useEffect(() => {
    if (!tabData || !tabData.component) {
      setComponentToRender(undefined);
      return;
    }
    if (tabData.componentName) {

      const c = tryGetComponent(tabData.component);
      if (c) {
        setComponentToRender({
          component: c,
          props: tabData.componentProps
        });
      } else {
        loadModuleComponent(tabData.componentName, error => {
          if (error) {
            logger.error('Error loading module component', error);
          } else {
            setComponentToRender({
              component: tabData.component(),
              props: tabData.componentProps
            });
          }
        });
      }
    } else {
      setComponentToRender({
        component: tabData.component(),
        props: tabData.componentProps
      });
    }

  }, [tabData]);
  if (componentToRender) {
    const RenderComponent = componentToRender.component;
    return React.createElement(RenderComponent, componentToRender.props);
  }
  return null;
});
const StaticTabs = _ref2 => {
  let {
    tabs
  } = _ref2;
  const currentTab = useCurrentTab();
  const {
    toTab
  } = useNavigationActions();
  const setUrl = param => {
    toTab(param);
  };
  return React.createElement(ItemsMenu, {
    branding: "racing-statistics-tabs",
    centered: true,
    hiddenScrollbar: true,
    scrollIcons: {
      left: 'caret-left',
      right: 'caret-right'
    },
    useScrollFaders: !svs.core.detect.formfactor.mobile(),
    useScrollHelpers: !svs.core.detect.formfactor.mobile()
  }, tabs.map(tab => React.createElement(LinkItem, {
    className: "link-item-label",
    fixedItem: tab.fixedItem,
    key: tab.label,
    label: tab.label,
    onClick: () => setUrl(tab.param),
    selected: currentTab === tab.param
  })));
};
svs.racing_game.components.staticTabs.StaticTabs = StaticTabs;
svs.racing_game.components.staticTabs.StaticTabsContent = StaticTabsContent;

 })(window);